// extracted by mini-css-extract-plugin
export default {"modalTitle":"CompanyValuationModal_modalTitle__ZFgmU","error":"CompanyValuationModal_error__7EGsa","successMessage":"CompanyValuationModal_successMessage__f9yNc"};